// extracted by mini-css-extract-plugin
module.exports = {"vanlife-E":"E_vanlife-E__NOIhK"};